import React, {useEffect, useState, useContext, useRef} from 'react';
import styled from "styled-components";
import Selection from "../../../molecules/selection/selection";
import {districtsSelection} from "../../../hooks/districts";
import {citiesSelection} from "../../../hooks/cities";
import {isEmpty} from "../../../helpers/helpers";
import ButtonBase from "../../../atoms/button.base";
import Icon from "../../../atoms/icon";
import PinIcon from '@icons/pin.svg';
import SearchIcon from "@icons/search.svg";
import RadioListGroup from "../../../atoms/radio.list.group";
import {AgenciesContext, AgenciesDispatcherContext} from "../../../providers/agencies_provider";
import {UpdateSelectionOptions} from "../../../hooks/selection.options";
import {makeAgenciesSearchUrl} from "./helpers";
import {useRouter} from "next/router";
import {getCityById} from "../../../../models/district";

const FormSection = ({searchTitle, page_type, city_id, district_id, handleItemsLists}) => {
    const districtsRef = useRef('');
    const router = useRouter();
    const agenciesDispatcher = useContext(AgenciesDispatcherContext);

    const [pageTypes, setPageTypes] = useState([
        {value: 'agencies', label: 'دفاتر املاک', checked: (page_type !== 'realtors')},
        {value: 'realtors', label: 'مشاورین املاک', checked: (page_type === 'realtors')},
    ]);
    const [selectedCity, setSelectedCity] = useState(null);
    const [cities, setCities] = useState({options: [], selected_items: []})
    const [districts, setDistrict] = useState({options: [], selected_items: []});
    const [districtLoading, setDistrictLoading] = useState(false);
    const [fields, setFields] = useState({
        page_type: page_type,
        city_id: '',
        district_id: '',
    });

    useEffect(() => {
        if (city_id !== fields.city_id) {
            setFields({
                page_type: page_type,
                city_id: city_id,
                district_id: district_id,
            })

            if (!isEmpty(city_id)) {
                getCities(city_id);
            }

            citiesSelection().then((result) => {
                if (result) {
                    const data = {
                        items: [city_id]
                    };
                    const citiesOptions = UpdateSelectionOptions(result.options, data);

                    setCities(citiesOptions);

                    if (citiesOptions && citiesOptions.selected_items && !isEmpty(citiesOptions.selected_items[0])) {
                        let districtData = null;

                        if (!isEmpty(district_id)) {
                            districtData = {
                                items: [district_id]
                            }
                        }

                        setTimeout(() => {
                            getDistricts(citiesOptions.selected_items[0], districtData)
                        }, 1500)
                    }
                }
            })
        }
    }, [city_id]);

    function getCities(cityId) {
        getCityById(cityId).then(city => {
            setSelectedCity(city)
        }).catch(err => {
            setTimeout(() => {
                getCities(cityId);
            }, 2000)
        });
    }

    const handleCityChange = (data) => {
        if (typeof data.items[0] !== "undefined") {
            const city_id = data.items[0];
            handleChange(null, 'city_id', city_id);

            getCities(city_id);
            getDistricts(city_id)
        }
    };

    const getDistricts = async (city_id, selected = null) => {
        setDistrictLoading(true);

        await districtsSelection(city_id).then(result => {
            let districtsOptions = result;

            if (!isEmpty(selected)) {
                districtsOptions = UpdateSelectionOptions(result.options, selected);
            }

            setDistrict(districtsOptions);
            setDistrictLoading(false);
        }).catch(err => {
            console.log(err)
        });
    };

    const handleDistrictChange = async (data) => {
        let district_id = null;

        if (typeof data.items[0] !== "undefined") {
            district_id = data.items[0];
        }

        handleChange(null, 'district_id', district_id);

        const new_option = UpdateSelectionOptions(districts.options, data, true);
        setDistrict(new_option)
    };

    const handleChange = (e, field = '', value = '') => {

        if (field === '' && value === '') {
            field = e.target.name;
            value = e.target.value;
        }

        let newFields = {...fields};
        newFields[field] = value;

        if (field === 'city_id') {
            newFields['district_id'] = '';

            if (!isEmpty(districtsRef) && !isEmpty(districtsRef.current)) {
                const selection = districtsRef.current.querySelector('.selection');
                if (selection) {
                    selection.classList.remove('selected');
                }
            }
        }

        setFields(newFields);

        if (field === 'page_type') {
            let newPageTypes = [...pageTypes];
            for (let item of newPageTypes) {
                item['checked'] = (item.value === value);
            }

            setPageTypes(newPageTypes);

            handleSkeleton(true);

            setTimeout(() => {
                handleSearch(null, value)
            }, 0)
        }
    };

    const handleSkeleton = (show) => {
        agenciesDispatcher({
            type: 'SET_SKELETON',
            payload: {
                skeleton: show
            }
        })
    }

    const handleSearch = (e, pageType = null) => {
        const {page_type, city_id, district_id} = fields;
        const pageTypeList = !isEmpty(pageType) ? pageType : page_type;

        handleSkeleton(true);

        handleItemsLists(pageTypeList, city_id, district_id, 1);

        makeAgenciesSearchUrl(pageTypeList, city_id, district_id).then(url => {
            if (url) {
                router.push('/users/agencies', url, {shallow: true});
            }
        })
    }

    return (
        <Container className="">
            <h1 className="text-center h1-bold">{searchTitle}</h1>

            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        <Form className="mt-32 mt-lg-40 d-lg-flex align-items-center">

                            <Card className="flex-1">
                                <Selection
                                    type="single"
                                    name="city_id"
                                    searchable
                                    clearabel={false}
                                    options={cities.options}
                                    selected_items={cities.selected_items}
                                    label="شهر"
                                    loading={false}
                                    icon={<PinIcon/>}
                                    onChange={(data) => handleCityChange(data)}
                                />
                            </Card>

                            {
                                (!isEmpty(selectedCity) && selectedCity.type === 'city') ?
                                    <Card ref={districtsRef} className="flex-1 mt-16 mt-lg-0">
                                        <Selection
                                            type="single"
                                            name="district_id"
                                            searchable
                                            options={districts.options}
                                            label="خیابان اصلی"
                                            loading={(districtLoading)}
                                            onChange={(data) => handleDistrictChange(data)}
                                        />
                                    </Card>
                                    : ''
                            }

                            <Card className="mt-16 mt-lg-0">
                                <ButtonBase color="secondary" onClick={handleSearch}>
                                    <Icon width={16} height={16} className="ml-8"><SearchIcon/></Icon>
                                    جستجو
                                </ButtonBase>
                            </Card>
                        </Form>
                    </div>
                </div>
            </div>

            <div className="container">
                <PageTypeCard className="d-flex align-items-center justify-content-center">
                    {
                        pageTypes.map((item, key) =>
                            <RadioListGroup
                                name="page_type"
                                key={key}
                                item={item}
                                onChange={handleChange}
                                className={"agencies-pages " + (key === 0 ? 'ml-8' : '')}
                            />
                        )
                    }
                </PageTypeCard>
            </div>
        </Container>
    );
};

export default React.memo(FormSection);

// styles

const Container = styled.div`

`;

const Form = styled.div`
  border: 1px solid ${props => props.theme.gray250};
  padding: 8px;
  border-radius: 8px;

  .selection {
    border: none;
    width: 100%;
  }

  @media (max-width: ${props => props.theme.screenSmMax}) {
    border: none;
    padding: 0;
    border-radius: 0;

    .selection {
      border-radius: 8px;
      background-color: #ebebeb;
    }

    .btn {
      width: 100%;
    }
  }
`;

const Card = styled.div`
  margin-left: 24px;
  padding-left: 24px;
  border-left: 1px solid ${props => props.theme.gray250};

  &:last-child {
    margin-left: 0;
    margin-right: -8px;
    padding-left: 0;
    border-left: none;
  }

  @media (max-width: ${props => props.theme.screenSmMax}) {
    margin-left: 0;
    margin-right: 0;
    padding-left: 0;
    border-left: none;

    &:last-child {
      margin-right: 0;
    }
  }
`;

const Section = styled.div`
  margin-top: 80px;

  .swiper-container {
    margin-bottom: -24px;
  }

  @media (max-width: ${props => props.theme.screenSmMax}) {
    margin-top: 56px;
  }
`;

const PageTypeCard = styled.div`
  margin-top: 80px;

  .agencies-pages {

    label {
      border-radius: 50rem;
      border: 0;
    }
  }

  @media (max-width: ${props => props.theme.screenSmMax}) {
    margin-top: 56px;
    border-bottom: 1px solid ${props => props.theme.gray200};

    .agencies-pages {

      label {
        border-radius: 0;
        border: 0;
        background: transparent !important;
        color: ${props => props.theme.black} !important;
        font-weight: 500;
      }

      input {

        &:checked + label {
          border-bottom: 2px solid ${props => props.theme.primary} !important;
        }
      }
    }
  }
`;